import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@utils/api';
import customEventBus from '@common/scripts/libs/eventBus';
import ClientServiceSection from './ClientServiceSection';
import ClientSrviceFAQSAccordion from './ClientSrviceFAQSAccordion';
import Button from '@stone/ui/button/Button';
//.hero-search class is for new faq search in CS Landing, .client-service-search class is for the old CS Landing search
const searchSelector = '.cs-hero';
const csContent = '.cs-page';
const FaqResults = (props) => {
    const { t } = useTranslation();
    const [results, setResults] = useState([]);
    const [emptyPrevious, setEmptyPrevious] = useState(false);
    const [query, setQuery] = useState('');
    // inizializzo i ref per gli elementi del dom fuori react
    const searchBlock = useRef(document.querySelector(searchSelector));
    const csBlock = useRef(document.querySelector(csContent));
    // add listener from outside via CustomEventBus
    useEffect(() => {
        customEventBus.on('faqSearch:update', (data) => {
            setResults(data.results);
        });
        customEventBus.on('query:update', (data) => {
            setQuery(data.query);
        });
    }, []);
    useEffect(() => {
        var _a, _b;
        if (query.length >= 1) {
            api.searchFaqs(query).then((data) => {
                var _a;
                if (data.results.length > 0) {
                    searchBlock.current.dataset.searchActive = 'res';
                }
                else {
                    searchBlock.current.dataset.searchActive = 'sugg';
                }
                setResults(data.results || []);
                setEmptyPrevious(false);
                (_a = csBlock.current) === null || _a === void 0 ? void 0 : _a.classList.add('hero-serach-active');
            });
        }
        else {
            setEmptyPrevious(true);
            (_a = searchBlock.current) === null || _a === void 0 ? void 0 : _a.removeAttribute('data-search-active');
            (_b = csBlock.current) === null || _b === void 0 ? void 0 : _b.classList.remove('hero-serach-active');
            setResults([]);
        }
    }, [query]);
    const getHtmlContent = (str) => {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: str } });
    };
    return ((query.length >= 1 && !emptyPrevious && (React.createElement(ClientServiceSection, { title: t('faqsearch.results') },
        React.createElement(Button, { cls: ['button--secondary'], onClick: () => {
                let resultsSection = document.getElementById('hero-searchbar');
                resultsSection === null || resultsSection === void 0 ? void 0 : resultsSection.focus();
            }, className: "visible-on-focus", type: 'button' }, t('faqsearch.a11y.tosearch')),
        React.createElement("div", { className: "faq-component__container", id: "faq-results", tabIndex: -1, "aria-label": t('faqsearch.results') },
            results.length === 0 && React.createElement("p", null, t('faqsearch.noresults', { text: query })),
            results.length > 0 && (React.createElement("div", { className: "details" },
                React.createElement(ClientSrviceFAQSAccordion, { faqs: results.map((res) => {
                        return {
                            title: res.name,
                            content: res.body,
                        };
                    }) }))))))) || React.createElement(React.Fragment, null));
};
export default FaqResults;
